import { PregnancyCompletionType } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { BindingCreator, useTranslate } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { gynecologicalInterviewTranslationKeys } from '../../../translations';

export type GynecologicalInterviewType = 'PATIENT_PREGNANT' | 'REGULAR_INTERVIEW' | PregnancyCompletionType;

const GYNECOLOGICAL_INTERVIEW_TYPE_FIELD_NAME = 'interviewType';

type GynecologicalInterviewTypeFormBeanPart = {
   [GYNECOLOGICAL_INTERVIEW_TYPE_FIELD_NAME]: GynecologicalInterviewType | null;
};

type GynecologicalInterviewTypeSelectProps = {
   readonly register: BindingCreator<
      GynecologicalInterviewTypeFormBeanPart,
      typeof GYNECOLOGICAL_INTERVIEW_TYPE_FIELD_NAME
   >;
};

const useTriggerLabelExtractor = (): ((value: GynecologicalInterviewType) => string) => {
   const translate = useTranslate();
   return (value) => {
      return translate(gynecologicalInterviewTranslationKeys.interviewType[value]);
   };
};

const interviewTypeItems: GynecologicalInterviewType[] = [
   'PATIENT_PREGNANT',
   'MISCARRIAGE',
   'DELIVERY',
   'DEAD_DELIVERY',
   'OTHER',
   'REGULAR_INTERVIEW',
];

export const GynecologicalInterviewTypeSelect = (props: GynecologicalInterviewTypeSelectProps): JSX.Element => {
   return (
      <Select<GynecologicalInterviewType>
         testId={'gynecologicalInterviewEntryType'}
         triggerLabelExtractor={useTriggerLabelExtractor()}
         controller={props.register(GYNECOLOGICAL_INTERVIEW_TYPE_FIELD_NAME, { required: true })}
         placeholder={gynecologicalInterviewTranslationKeys.choose}
         label={gynecologicalInterviewTranslationKeys.type}
      >
         <Select.List<GynecologicalInterviewType> items={interviewTypeItems}>
            {(item: GynecologicalInterviewType) => (
               <Select.Item
                  item={item}
                  label={gynecologicalInterviewTranslationKeys.interviewType[item]}
                  testId={item}
               />
            )}
         </Select.List>
      </Select>
   );
};
